<div class="audit-archives-container">
    <!-- Header -->
    <div class="header-section mb-3">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="mb-0">
                <i class="fa-solid fa-archive me-2"></i>
                Arhive Audit
            </h3>
            <div class="header-actions">
                <!-- Tab buttons -->
                <button class="btn me-2" [class.btn-primary]="activeTab === 'management'"
                    [class.btn-outline-primary]="activeTab !== 'management'" (click)="switchTab('management')">
                    <i class="fa-solid fa-cog me-1"></i>
                    Management
                </button>
                <button class="btn" [class.btn-primary]="activeTab === 'viewer'"
                    [class.btn-outline-primary]="activeTab !== 'viewer'" [disabled]="!archiveStatus.has_active_session"
                    (click)="switchTab('viewer')">
                    <i class="fa-solid fa-eye me-1"></i>
                    Vizualizare
                </button>
            </div>
        </div>
    </div>

    <!-- Active Session Banner -->
    <div class="session-banner mb-3" *ngIf="archiveStatus.has_active_session && archiveStatus.session">
        <div class="alert alert-info d-flex justify-content-between align-items-center mb-0">
            <div>
                <i class="fa-solid fa-database me-2"></i>
                <strong>Arhivă încărcată:</strong> {{ archiveStatus.session.period_label }}
                <span class="ms-3">|</span>
                <span class="ms-3">{{ archiveStatus.session.records_imported | number }} înregistrări</span>
                <span class="ms-3">|</span>
                <span class="ms-3">Expiră: {{ archiveStatus.session.expires_at }}</span>
                <span class="ms-3 text-muted">({{ archiveStatus.session.time_remaining }})</span>
            </div>
            <button class="btn btn-outline-danger btn-sm" (click)="unloadArchive()">
                <i class="fa-solid fa-times me-1"></i>
                Descarcă
            </button>
        </div>
    </div>

    <!-- MANAGEMENT TAB -->
    <div *ngIf="activeTab === 'management'">
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0">
                    <i class="fa-solid fa-folder-open me-2"></i>
                    Arhive Disponibile
                </h5>
            </div>
            <div class="card-body">
                <!-- Loading -->
                <div class="text-center py-5" *ngIf="isLoadingArchives">
                    <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
                    <p class="mt-2 text-muted">Se încarcă lista arhivelor...</p>
                </div>

                <!-- No archives -->
                <div class="text-center py-5" *ngIf="!isLoadingArchives && availableArchives.length === 0">
                    <i class="fa-solid fa-folder-open fa-3x text-muted mb-3"></i>
                    <p class="text-muted">Nu există arhive disponibile.</p>
                    <p class="text-muted small">Arhivele sunt generate automat în prima zi a fiecărei luni.</p>
                </div>

                <!-- Archives list -->
                <div class="table-responsive" *ngIf="!isLoadingArchives && availableArchives.length > 0">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Perioadă</th>
                                <th>Fișier</th>
                                <th class="text-end">Nr. Înregistrări</th>
                                <th class="text-end">Dimensiune</th>
                                <th class="text-center">Acțiuni</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let archive of availableArchives">
                                <td>
                                    <strong>{{ archive.period_label }}</strong>
                                </td>
                                <td>
                                    <code class="small">{{ archive.filename }}</code>
                                </td>
                                <td class="text-end">
                                    {{ archive.record_count ? (archive.record_count | number) : '-' }}
                                </td>
                                <td class="text-end">
                                    {{ archive.file_size_formatted }}
                                </td>
                                <td class="text-center">
                                    <button class="btn btn-sm btn-success"
                                        [disabled]="archiveStatus.has_active_session || loadingArchivePath === archive.path"
                                        (click)="loadArchive(archive)">
                                        <mat-spinner diameter="14" *ngIf="loadingArchivePath === archive.path"
                                            class="me-1"></mat-spinner>
                                        <i class="fa-solid fa-upload me-1"
                                            *ngIf="loadingArchivePath !== archive.path"></i>
                                        Încarcă
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Info box -->
                <div class="alert alert-secondary mt-3 mb-0" *ngIf="!isLoadingArchives && availableArchives.length > 0">
                    <i class="fa-solid fa-info-circle me-2"></i>
                    <strong>Notă:</strong> Puteți încărca o singură arhivă la un moment dat.
                    Datele importate sunt temporare și vor fi șterse automat după 24 de ore sau manual prin butonul
                    "Descarcă".
                </div>
            </div>
        </div>
    </div>

    <!-- VIEWER TAB -->
    <div *ngIf="activeTab === 'viewer' && archiveStatus.has_active_session">
        <div class="header-actions-viewer mb-3 d-flex justify-content-end">
            <button class="btn btn-outline-primary me-2" (click)="toggleFilters()">
                <i class="fa-solid fa-filter me-1"></i>
                Filtre
            </button>
            <button class="btn btn-success" (click)="exportCsv()" [disabled]="isExporting">
                <mat-spinner diameter="18" *ngIf="isExporting" class="me-1"></mat-spinner>
                <i class="fa-solid fa-download me-1" *ngIf="!isExporting"></i>
                Export CSV
            </button>
        </div>

        <!-- Filters Card -->
        <div class="filters-card mb-3" *ngIf="showFilters">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <label class="form-label">Data de la</label>
                            <input type="date" class="form-control" [(ngModel)]="dateFrom">
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Data până la</label>
                            <input type="date" class="form-control" [(ngModel)]="dateTo">
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Modul</label>
                            <select class="form-select" [(ngModel)]="moduleFilter">
                                <option value="">Toate</option>
                                <option *ngFor="let module of modules" [value]="module.value">{{ module.label }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Acțiune</label>
                            <select class="form-select" [(ngModel)]="actionFilter">
                                <option value="">Toate</option>
                                <option *ngFor="let action of actions" [value]="action.value">{{ action.label }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Utilizator</label>
                            <input type="text" class="form-control" [(ngModel)]="userNameFilter"
                                placeholder="Nume utilizator">
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">Căutare</label>
                            <input type="text" class="form-control" [(ngModel)]="searchFilter" placeholder="Căutare...">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 d-flex justify-content-end">
                            <button class="btn btn-secondary me-2" (click)="resetFilters()">
                                <i class="fa-solid fa-times me-1"></i>
                                Resetează
                            </button>
                            <button class="btn btn-primary" (click)="applyFilters()">
                                <i class="fa-solid fa-search me-1"></i>
                                Aplică
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- DataTable -->
        <div class="table-responsive">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                class="table table-striped table-bordered w-100">
            </table>
        </div>

        <!-- Loading Overlay -->
        <div class="loading-overlay" *ngIf="isLoading">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
    </div>

    <!-- No archive loaded message for viewer tab -->
    <div *ngIf="activeTab === 'viewer' && !archiveStatus.has_active_session">
        <div class="text-center py-5">
            <i class="fa-solid fa-database fa-3x text-muted mb-3"></i>
            <p class="text-muted">Nu există arhivă încărcată.</p>
            <p class="text-muted small">Accesați tab-ul "Management" pentru a încărca o arhivă.</p>
            <button class="btn btn-primary mt-2" (click)="switchTab('management')">
                <i class="fa-solid fa-cog me-1"></i>
                Mergi la Management
            </button>
        </div>
    </div>
</div>